export enum ChallengeTag {
    data = 'Data Science',
    design = 'Website Design',
    findMe = 'Find Me Data',
    qa = 'Quality Assurance',
}
